
import { AuthConfig, B2CPolicy } from '@/types/auth';
import { FACADE, redirectUriPour } from './facade/resolveFacade';

// Configuration Azure B2C
const b2cPolicies: B2CPolicy = {
    signUpSignIn: process.env.REACT_APP_B2C_SIGNUP_SIGNIN_POLICY || 'B2C_1_signupsignin1',
    signIn: process.env.REACT_APP_B2C_SIGNIN_POLICY || 'B2C_1_signin',
    editProfile: process.env.REACT_APP_B2C_EDIT_PROFILE_POLICY || 'B2C_1_editprofil1',
    forgotPassword: process.env.REACT_APP_B2C_FORGOT_PASSWORD_POLICY || 'B2C_1_resetpass',
};

// Configuration MSAL
export const msalConfig: AuthConfig & { knownAuthorities?: string[] } = {
    clientId: process.env.REACT_APP_B2C_CLIENT_ID || '',
    // Correction : endpoint authority sans /tfp/ (pattern moderne)
    authority: `https://${process.env.REACT_APP_B2C_TENANT_NAME}.b2clogin.com/${process.env.REACT_APP_B2C_TENANT_NAME}.onmicrosoft.com/${b2cPolicies.signIn}`,
    // Sous la façade Azaria (C26 SP3, spec § 0.2), la connexion revient sur l'hôte courant, pas sur l'adresse
    // du build ; même annuaire, même application B2C — ses adresses de retour doivent lister le domaine.
    redirectUri: redirectUriPour(FACADE.facade, process.env, window.location.origin, 'REACT_APP_B2C_REDIRECT_URI'),
    postLogoutRedirectUri: redirectUriPour(FACADE.facade, process.env, window.location.origin, 'REACT_APP_B2C_POST_LOGOUT_REDIRECT_URI'),
    // IMPORTANT : openid et offline_access sont OBLIGATOIRES pour obtenir un accessToken complet
    // - openid : permet d'obtenir l'idToken
    // - offline_access : permet d'obtenir un refreshToken et un accessToken
    // - Le scope API custom vient en complément
    scopes: [
        'openid',
        'offline_access',
        ...(process.env.REACT_APP_B2C_SCOPE 
            ? process.env.REACT_APP_B2C_SCOPE.split(' ').filter(s => s !== 'openid' && s !== 'offline_access') 
            : ['https://anagogia.onmicrosoft.com/f7bdb13e-a342-48a9-ba77-495744430e52/tasks.read']
        )
    ],
    knownAuthorities: [
        `${process.env.REACT_APP_B2C_TENANT_NAME}.b2clogin.com`
    ],
};

// Requêtes de token
export const tokenRequest = {
    scopes: msalConfig.scopes,
};

// Requête de connexion
export const loginRequest = {
    scopes: msalConfig.scopes,
    authority: msalConfig.authority,
};

// Configuration des politiques
export const b2cPolicyConfig = {
    authorities: {
        signUpSignIn: {
            authority: `https://${process.env.REACT_APP_B2C_TENANT_NAME}.b2clogin.com/${process.env.REACT_APP_B2C_TENANT_NAME}.onmicrosoft.com/${b2cPolicies.signUpSignIn}`,
        },
        editProfile: {
            authority: `https://${process.env.REACT_APP_B2C_TENANT_NAME}.b2clogin.com/${process.env.REACT_APP_B2C_TENANT_NAME}.onmicrosoft.com/${b2cPolicies.editProfile}`,
        },
        forgotPassword: {
            authority: `https://${process.env.REACT_APP_B2C_TENANT_NAME}.b2clogin.com/${process.env.REACT_APP_B2C_TENANT_NAME}.onmicrosoft.com/${b2cPolicies.forgotPassword}`,
        },
    },
    authorityDomain: `${process.env.REACT_APP_B2C_TENANT_NAME}.b2clogin.com`,
};

// Configuration cache MSAL
export const cacheConfig = {
    cacheLocation: 'localStorage' as const,
    storeAuthStateInCookie: false,
};

// Configuration système MSAL
export const systemConfig = {
    loggerOptions: {
        loggerCallback: (level: any, message: string, containsPii: boolean) => {
            if (containsPii) {
                return;
            }
            // En production, on ne log que les erreurs
            if (process.env.NODE_ENV !== 'development') {
                if (level === 'Error') {
                    console.error(message);
                }
                return;
            }
            // En développement, on peut voir tous les logs si nécessaire
            switch (level) {
                case 'Error':
                    console.error(message);
                    return;
                case 'Info':
                    // Moins de bruit - on peut commenter ces lignes
                    // console.info(message);
                    return;
                case 'Verbose':
                    // console.debug(message);
                    return;
                case 'Warning':
                    console.warn(message);
                    return;
                default:
                    // console.log(message);
            }
        },
    },
};

export { b2cPolicies };
